export const stagingServer = 'https://api.develpment.node.vanguard.skunktest.work/api/';
export const PreProdServer = 'https://api.develpment.laravel.vanguard.skunktest.work/api/';
export const ProdServer = 'https://api.dev.node.vanguard.skunktest.work/api/';

// const baseURL = 'https://api.develpment.node.vanguard.skunktest.work/api/'; //  statging url
// // const baseURL = 'https://api.develpment.laravel.vanguard.skunktest.work/api/';
// // const baseURL = 'https://api.dev.node.vanguard.skunktest.work/api/'; //  production url
